// extracted by mini-css-extract-plugin
export var actionButton = "_7d-1";
export var actionButtons = "_7d-2";
export var actions = "_7d-0";
export var aiUnread = "_7d-10";
export var alignCenter = "_7d-h";
export var backWrapper = "_7d-3";
export var cellContainer = "_7d-4";
export var checkboxContainer = "_7d-5";
export var contentContainer = "_7d-6";
export var contentHeader = "_7d-8";
export var conversationsTableWrapper = "_7d-s";
export var draftReplyBadgeContainer = "_7d-m";
export var dropdownItem = "_7d-b";
export var dropdownItemsContainer = "_7d-a";
export var dropdownTitle = "_7d-c";
export var errorIcon = "_7d-7";
export var filter = "_7d-d";
export var gray = "_7d-i";
export var headerActionButtons = "_7d-e";
export var headerCheckboxContainer = "_7d-f";
export var icon = "_7d-j";
export var menuContainer = "_7d-k";
export var noMoreTicketsIcon = "_7d-12";
export var noMoreTicketsSubText = "_7d-13";
export var oneLine = "_7d-l";
export var optionsButton = "_7d-n";
export var plus = "_7d-o";
export var portalButtonsWrapper = "_7d-g";
export var red = "_7d-p";
export var scrolledTop = "_7d-9";
export var search = "_7d-q";
export var selectedConversationsCount = "_7d-r";
export var spinner = "_7d-t";
export var strong = "_7d-u";
export var summaryCell = "_7d-v";
export var tableContainer = "_7d-11";
export var tagContainer = "_7d-w";
export var threeDots = "_7d-x";
export var twoLines = "_7d-y";
export var unread = "_7d-z";